import React from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import DateFnsUtils from '@date-io/date-fns';
import BuildingsCheckList from '../containers/Filters/buildingsCheckList';
import ClassroomCheckList from '../containers/Filters/classroomCheckList';
import PeriodCheckList from '../containers/Filters/periodCheckList';
import ParametersCheckList from '../containers/Filters/parametersCheckList';
import DateRangeSelect from '../containers/Filters/dateRangeSelect';
import MonthRangeSelect from '../containers/Filters/monthRangeSelect';
import DayPeriodSelect from '../containers/Filters/dayPeriodSelect';
import BuildingSelect from '../containers/Filters/buildingSelect';
import DaySelect from '../containers/Filters/daySelect';
import MonthSelect from '../containers/Filters/monthSelect';
import SpaceTimeSelector from '../containers/Filters/spaceTimeSelector';
import Box from '@mui/material/Box';
import DaysOfWeekFilter from '../containers/Filters/daysOfWeekFilter';
import { BUILDINGS_CHECKLIST, CLASSROOM_CHECKLIST, DATE_RANGE_SELECT, DAY_PERIOD_SELECT, PARAMETERS_CHECKLIST, BUILDING_SELECT, DAY_SELECT, MONTH_RANGE_SELECT, MONTH_SELECT, PERIOD_CHECKLIST, SPACE_TIME_SELECTOR, DAYS_OF_WEEK_FILTER } from '../helpers/constants';

const PREFIX = 'Filters';

const classes = {
  title: `${PREFIX}-title`,
  paper: `${PREFIX}-paper`
};

const Root = styled('div ')((
  {
    theme
  }
) => ({
  [`& .${classes.title}`]: {
    textAlign: 'center'
  },

  [`& .${classes.paper}`]: {
    width: '100%',
    maxHeight: 435,
  }
}));

function Filters(props) {
  const { filters } = props;

  const [dense, setDense] = React.useState(false);

  var filtersArrayComponent = []
  for (var i = 0; i < filters.length; i++) {

    switch (parseInt(filters[i].filterId)) {
      case BUILDINGS_CHECKLIST:
        filtersArrayComponent.push(
          <BuildingsCheckList {...props}
            id={filters[i].filterId}
            name={filters[i].filterName}
            data={filters[i].filterData}
            required={filters[i].required}
            defines = {filters[i].defines}
            key={i}
          />);
        break;
      case CLASSROOM_CHECKLIST:
        filtersArrayComponent.push(
          <ClassroomCheckList {...props}
            id={filters[i].filterId}
            name={filters[i].filterName}
            data={filters[i].filterData}
            required={filters[i].required}
            defines = {filters[i].defines}
            key={i}
          />);
        break;
      case DATE_RANGE_SELECT:
        filtersArrayComponent.push(
          <DateRangeSelect {...props}
            id={filters[i].filterId}
            name={filters[i].filterName}
            data={filters[i].filterData}
            required={filters[i].required}
            defines = {filters[i].defines}
            key={i}
          />);
        break;
      case DAY_PERIOD_SELECT:
        filtersArrayComponent.push(
          <DayPeriodSelect {...props}
            id={filters[i].filterId}
            name={filters[i].filterName}
            data={filters[i].filterData}
            required={filters[i].required}
            defines = {filters[i].defines}
            key={i}
          />);
        break;
      case PARAMETERS_CHECKLIST:
        filtersArrayComponent.push(
          <ParametersCheckList {...props}
            id={filters[i].filterId}
            name={filters[i].filterName}
            data={filters[i].filterData}
            required={filters[i].required}
            defines = {filters[i].defines}
            key={i}
          />);
        break;
      case BUILDING_SELECT:
        filtersArrayComponent.push(
          <BuildingSelect {...props}
            id={filters[i].filterId}
            name={filters[i].filterName}
            data={filters[i].filterData}
            required={filters[i].required}
            defines = {filters[i].defines}
            key={i}
          />);
        break;
      case DAY_SELECT:
        filtersArrayComponent.push(
          <DaySelect {...props}
            id={filters[i].filterId}
            name={filters[i].filterName}
            data={filters[i].filterData}
            required={filters[i].required}
            defines = {filters[i].defines}
            key={i}
          />);
        break;
      case MONTH_RANGE_SELECT:
        filtersArrayComponent.push(
          <MonthRangeSelect {...props}
            id={filters[i].filterId}
            name={filters[i].filterName}
            data={filters[i].filterData}
            required={filters[i].required}
            defines = {filters[i].defines}
            key={i}
          />);
        break;
      case MONTH_SELECT:
        filtersArrayComponent.push(
          <MonthSelect {...props}
            id={filters[i].filterId}
            name={filters[i].filterName}
            data={filters[i].filterData}
            required={filters[i].required}
            defines = {filters[i].defines}
            key={i}
          />);
        break;
      case PERIOD_CHECKLIST:
        filtersArrayComponent.push(
          <PeriodCheckList {...props}
            id={filters[i].filterId}
            name={filters[i].filterName}
            data={filters[i].filterData}
            required={filters[i].required}
            defines = {filters[i].defines}
            key={i}
          />);
        break;
      case SPACE_TIME_SELECTOR:
        filtersArrayComponent.push(
          <SpaceTimeSelector {...props}
            id={filters[i].filterId}
            name={filters[i].filterName}
            data={filters[i].filterData}
            required={filters[i].required}
            defines = {filters[i].defines}
            subFilters = {filters[i].subFilters}
            key={i}
          />);
        break;
      case DAYS_OF_WEEK_FILTER:
        filtersArrayComponent.push(
          <DaysOfWeekFilter {...props}
            id={filters[i].filterId}
            name={filters[i].filterName}
            data={filters[i].filterData}
            required={filters[i].required}
            defines = {filters[i].defines}
            key={i}
          />);
        break;
      default:
        break;
    }
  }

  return (
    <div>
      <List dense={dense} sx={{maxHeight: '65vh', overflow: 'auto'}} >

        <ListItem >
          <ListItemText
            primary={
              <div >
                <Typography component={'div'} variant="body1">
                  <Box style={{ margin: 0 }} textAlign="center" fontWeight="fontWeightMedium" m={1}>Filtros de gráficos</Box>
                </Typography>
                <Typography component={'div'} variant="body2">
                  <Box textAlign="center" color="error.main">* Campos requeridos</Box>
                </Typography>
              </div>
            }
          />
        </ListItem>

        <Divider />
        {filtersArrayComponent}
      </List>

    </div >
  )
}

export default Filters;